export default [
  {
    title: 'Portal de propostas',
    route: { name: 'portalproposta-externo' },
    icon: '',
    resource: 'portalpropostaexterno',
    action: 'read',
  },
]
